import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Modal from 'widgets/Modal/Modal';

import CreateReviewAddReview from '../../containers/CreateReviewAddReview';
import CreateReviewAddDetails from '../../containers/CreateReviewAddDetails';

export default class CreateReview extends PureComponent {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    sku: PropTypes.string.isRequired,
    step: PropTypes.oneOf(['addReview', 'addDetails']).isRequired,
    updateFields: PropTypes.func.isRequired,
    rating: PropTypes.number,
  };

  closeAndClear = () => {
    this.props.updateFields({
      rating: 0,
      recommended: null,
      termAgreed: false,
      reviewTitle: '',
      reviewText: '',
      newNickname: undefined,
      step: 'addReview',
      validationErrors: [],
    });
    this.props.onClose();
  };

  currentAddReviewStep() {
    const {
      sku,
      step,
      rating,
    } = this.props;
    switch (step) {
      case 'addDetails':
        return (
          <CreateReviewAddDetails
            sku={sku}
            onSave={this.closeAndClear}
          />
        );
      default:
        return (
          <CreateReviewAddReview
            sku={sku}
            onSave={this.closeAndClear}
            rating={rating}
          />
        );
    }
  }

  render() {
    return (
      <Modal
        mobileFullWindow={false}
        title="Leave a rating and review"
        onCancel={this.closeAndClear}
      >
        {this.currentAddReviewStep()}
      </Modal>
    );
  }
}
